import { useParams } from 'react-router-dom';

export const useCandidateId = () => {
  const params = useParams<Dictionary<string>>();

  return params.id!;
};
